export default {
  "content": "<g clip-path=\"url(#clip0)\"><path d=\"M7.568 1.242a.5.5 0 01.864 0l2.043 3.508a.5.5 0 00.327.237l3.968.86a.5.5 0 01.267.821L12.33 9.695a.5.5 0 00-.124.384l.409 4.04a.5.5 0 01-.7.507l-3.714-1.637a.5.5 0 00-.404 0l-3.715 1.637a.5.5 0 01-.699-.508l.41-4.04a.5.5 0 00-.125-.383L.964 6.668a.5.5 0 01.267-.822l3.967-.859a.5.5 0 00.327-.237l2.043-3.508z\" fill=\"#ff00cb\"/></g><defs><clipPath id=\"clip0\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};